module.exports = __webpack_public_path__ + "static/media/iconOffTarget.9dae28a2.svg";